import { ViewChild, Component, Input } from '@angular/core';
import { GlobalProvider } from '../../providers/global/global';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AlertController, NavController, NavParams } from 'ionic-angular';
import { isNumber } from 'ionic-angular/umd/util/util';
import * as momentNs from 'moment';
const moment = momentNs;
/**
 * Generated class for the Timesheet1Component component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'timesheet1',
  templateUrl: 'timesheet1.html'
})

export class Timesheet1Component {
  @ViewChild('picker1') picker1;
  //shownGroup = null;

  // dt1: any;
  // dt2: any;
  //dt1table1:any;
  //dt2table1:any;

  customAvailabilityAlertOptions: any = {
    title: 'Days',
  };

  time;
  day;
  newMin: string;
  newMax: string;
  interval: number;
  minuteItervals: Array<number>;
  minuteItervalsString: string;
  hourInterval: Array<number>
  hourItervalsString: string;
  startEndHoursString: string;
  res2: any;
  grid2: string;
  save_res: string;
  save_data: any;
  tab2id: string;
  res1: any;
  quantity6: string;
  quantity7: string;

  iRow: number;
  jDay: number;
  tempStartTime: string;
  tempEndTime: string;
  tempBreakTime: string;
  tempTotalTime: string;
  tempDay: string;

  tempDisableGrid2Change: boolean = false;

  x: string = null;

  dt1table1_original: any;
  allowbetweeninterval: boolean = false;

  options: Array<any> = [];


  show_timesheetinstructions0: boolean = false;
  show_timesheetinstructions1: boolean = false;

  constructor(public http: HttpClient, public global: GlobalProvider, public navCtrl: NavController,
    public navParams: NavParams, private alertCtrl: AlertController) {

    if (this.global.grid1Visibility) {

      this.global.dt1table1 = JSON.parse(this.global.dt_grid1[0]);
      this.dt1table1_original = this.global.dt1table1;

      this.resolve_grid1_t1();

      //console.log('hello2', this.global.dt1table1);

      this.allowbetweeninterval = this.global.dt1table1[0].AllowBetweenInterval;
      this.global.CTRLInterval = this.global.dt1table1[0].CTRLInterval;
      // this.global.CTRLMin = this.dt1table3[0].CTRLMin;
      // this.global.CTRLMax = this.dt1table3[0].CTRLMax;

      //nRows represent the number of rows to be drawn in Grid1, whether there will be overtime,.. or not.
      this.global.nrowsGrid1 = this.global.dt1table1.length;
      //console.log('nRowsGrid1: ' + this.global.nrowsGrid1);

      // nDays represent the number of days in the timesheet, it can be any number between 1 and 7
      for (var i = 0; i <= this.global.TAB2Caption.length; i++) {
        if (this.global.TAB2Caption[i] == "Expenses" || this.global.TAB2Caption[i] == "Totals") {
          this.global.ndays = i;
          break;
        }
        else {
          this.global.ndays = this.global.TAB2Caption.length;
        }
      }

      // for(var i = 0; i <= 7 ; i++){
      //   if (this.global.TAB2Caption[i] == "Expenses" || this.global.TAB2Caption[i] == "Totals"){
      //     this.global.ndays = i ;
      //     break;
      //   }
      //   else {
      //     this.global.ndays = 7;
      //   }
      // }
      //console.log('nDays: ' + this.global.ndays);
    }
    if (this.global.grid2Visibility) {
      //console.log('data of grid2 existed: ' + this.global.dt_grid2.length);
      this.global.dt2table1 = JSON.parse(this.global.dt_grid2[0]);

      //nRows represent the number of rows to be drawn in Grid2, whether there will be overtime,.. or not.
      this.global.nrowsGrid2 = this.global.dt2table1.length;
      // console.log('nRowsGrid2: ' + this.global.nrowsGrid2);

      //get grid2 ddl options 
      this.global.setGrid2Option();

    }

    this.timeInterval();

    if (this.global.contacttype == '0') {
      this.show_timesheetinstructions0 = true;
    }
    if (this.global.contacttype == '1') {
      this.show_timesheetinstructions1 = true;
    }


    
    // var self = this;
    // setTimeout(function(){      self.toggleGroup(0)
    // }, 500);
  }

  resolve_grid1_t1() {
    //default is what the picker opens to
    //start/end/break is what is displayed on screen
    //always display start/end/break
    //if start/break/end are zero - open to default , else open to start/break/end
    //should read based on timeinputcontrol , but always save as 24 hours
    for (var i = 0; i < this.global.dt1table1.length; i++) {

      if (this.global.TimeInputControl == '24') {
        this.global.dt1table1[i]['StartTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['StartTime']);
        this.global.dt1table1[i]['FinishTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['FinishTime']);
      }

      if (this.global.dt1table1[i]['StartTime'] != "00:00 AM" && this.global.dt1table1[i]['StartTime'] != "00:00") {
        this.global.dt1table1[i]['DefaultStartTime'] = this.global.dt1table1[i]['StartTime'];
      }
      if (this.global.dt1table1[i]['FinishTime'] != "00:00 AM" && this.global.dt1table1[i]['FinishTime'] != "00:00") {
        this.global.dt1table1[i]['DefaultEndTime'] = this.global.dt1table1[i]['FinishTime'];
      }
      if (this.global.dt1table1[i]['BreakTime'] != "00:00 AM" && this.global.dt1table1[i]['BreakTime'] != "00:00") {
        this.global.dt1table1[i]['DefaultBreakTime'] = this.global.dt1table1[i]['BreakTime'];
      }

      this.global.dt1table1[i]['DefaultStartTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['DefaultStartTime']);
      this.global.dt1table1[i]['DefaultEndTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[i]['DefaultEndTime']);

      if(this.global.dt1table1[i]['BreakMins']=='1'){
        this.global.dt1table1[i]['BreakMins'] = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59';
      }
      
    }
  }

  toggleGroup(group) {
    if (this.isGroupShown(group)) {
      this.global.shownGroup = null;
    } else {
      this.global.shownGroup = group;
    }
  }

  isGroupShown(group) {
    // debugger
    return this.global.shownGroup === group;
  }

  showGrid1ResetConfirm(iRowClicked) {
    var self = this;
    const confirm = this.alertCtrl.create({
      title: 'Are you sure you want to reset this entry?',
      message: 'This will action will clear Start / End / Break times on  ' + this.global.dt1table1[iRowClicked]["Type"] + " ?",
      buttons: [
        {
          text: 'Cancel',
          handler: () => {
            console.log('Cancel Clicked');
          }
        },
        {
          text: 'Reset',
          handler: () => {
            self.resetGrid1Entry(iRowClicked);
          }
        }
      ]
    });
    confirm.present();
  }

  resetGrid1Entry(iRowClicked) {
    this.iRow = iRowClicked;
    
    this.global.dt1table1[iRowClicked]['StartTime'] = "00:00";
    this.global.dt1table1[iRowClicked]['FinishTime'] = "00:00";
    this.global.dt1table1[iRowClicked]['BreakTime'] = "00:00";

    
    this.global.dt1table1[iRowClicked]['TotalTime'] = "00:00";
    
    this.httpRequestGrid1_save(1, 'CHECK', "00:00");

  }

  t_convert_ampm_to_24(t: string) {
    if (t.includes("AM") || t.includes("PM")) {
      var time = t;
      var hours = Number(time.match(/^(\d+)/)[1]);
      var minutes = Number(time.match(/:(\d+)/)[1]);
      var AMPM = time.match(/\s(.*)$/)[1];
      if (AMPM == "PM" && hours < 12) hours = hours + 12;
      if (AMPM == "AM" && hours == 12) hours = hours - 12;
      var sHours = hours.toString();
      var sMinutes = minutes.toString();
      if (hours < 10) sHours = "0" + sHours;
      if (minutes < 10) sMinutes = "0" + sMinutes;
      return (sHours + ":" + sMinutes);
    }
    else {
      return t;
    }
  }

  t_convert_24_to_ampm(time24: string) {
    if (!(time24.includes("AM") || time24.includes("PM"))) {
      var ts = time24;
      var H = parseInt(ts.substr(0, 2));
      // console.log('H:'+H)
      var h = (H % 12) || 12;
      var v = (h < 10) ? ("0" + String(h)) : String(h);  // leading 0 at the left for 1 digit hours
      var ampm = H < 12 ? " AM" : " PM";
      ts = v + ts.substr(2, 3) + ampm;
      return ts;
    } else {
      return time24;
    }
  };

  calculateTotalTime(startime: string, endtime: string, breaktime: string) {
    var then = "04/09/2013 " + startime;
    var now = "04/09/2013 " + endtime;
    var Break = "04/09/2013 " + breaktime;

    var diff1 = moment.utc(moment(now, "DD/MM/YYYY HH:mm:ss aa").diff(moment(then, "DD/MM/YYYY HH:mm:ss aa"))).format("HH:mm:ss");

    var diff1Date = "04/09/2013 " + diff1;

    var outputdiff = moment.utc(moment(diff1Date, "DD/MM/YYYY HH:mm:ss aa").diff(moment(Break, "DD/MM/YYYY HH:mm"))).format("HH:mm");

    return outputdiff;
  }


  httpRequestGrid1_save(gridtype: number, action: string, value: string) {


    var p: any = {};

    p.timesheetid = this.global.timesheetid;
    p.contacttype = this.global.contacttype;
    p.action = action;
    p.value = value;
    p.datadate = this.global.TAB2id[this.global.tab2index];

    if (gridtype == 1) {
      p.contractid = this.global.dt1table1[this.iRow].ContractId;

      var start = this.global.dt1table1[this.iRow]['StartTime'];
      var finish = this.global.dt1table1[this.iRow]['FinishTime'];


      p.starttime = this.t_convert_ampm_to_24(start);
      p.endtime = this.t_convert_ampm_to_24(finish);
      p.breaktime = this.global.dt1table1[this.iRow]['BreakTime'];

      // if(this.global.dt1table1[this.iRow]['StartTime'].includes("AM")||this.global.dt1table1[this.iRow]['StartTime'].includes("PM")){
      //   p.starttime = this.t_convert_ampm_to_24(start);
      // } else {
      //   p.starttime = this.global.dt1table1[this.iRow]['StartTime'];
      // }

      // if(this.global.dt1table1[this.iRow]['FinishTime'].includes("AM")||this.global.dt1table1[this.iRow]['FinishTime'].includes("PM")){
      //   p.endtime = this.t_convert_ampm_to_24(finish);
      // } else {
      //   p.endtime = this.global.dt1table1[this.iRow]['FinishTime'];
      // }


      // p.starttime = this.global.dt1table1[this.iRow]['StartTime'];
      // p.endtime = this.global.dt1table1[this.iRow]['FinishTime'];
      // p.breaktime = this.global.dt1table1[this.iRow]['BreakTime'];
    }

    else if (gridtype == 2) {
      p.contractid = this.global.dt2table1[this.iRow].ContractId;
    }



    if (gridtype == 1) {
      p.ratesid = this.global.dt1table1[this.iRow].RatesId;
    }
    else if (gridtype == 2) {
      p.ratesid = this.global.dt2table1[this.iRow].RatesId;
    }


    const params = new HttpParams().set('j', JSON.stringify(p))

    this.http.post('timesheets/timesheet_save/', params).subscribe(

      (data) => {

        this.save_data = data;
        this.save_res = JSON.parse(this.save_data.dt)[0].Result;

        if (this.save_res.substring(0, 2) == 'WA') {

          this.presentWAConfirm(gridtype, value, this.save_res);
        }
        else if (this.save_res.substring(0, 2) == 'NA') {

          this.presentNAalert(gridtype, this.save_res);
        }

      },
      error => {
        //alert('error');
        // //debugger;
      }
    );


  }

  presentWAConfirm(gridtype: number, value: string, resMsg: string) {
    let alert = this.alertCtrl.create({
      message: resMsg.replace('WA', ''),
      buttons: [
        {
          text: 'Yes',
          handler: () => {
            //console.log('Yes clicked');

            this.httpRequestGrid1_save(gridtype, 'SAVE', value );



          }
        },
        {
          text: 'No',
          role: 'cancel',
          handler: () => {
            //debugger
            if (gridtype == 1) {
              this.global.dt1table1[this.iRow]['StartTime'] = this.tempStartTime;
              this.global.dt1table1[this.iRow]['FinishTime'] = this.tempEndTime;
              this.global.dt1table1[this.iRow]['BreakTime'] = this.tempBreakTime;
              this.global.dt1table1[this.iRow]['TotalTime'] = this.tempTotalTime;
            } else if (gridtype == 2) {
              this.tempDisableGrid2Change = true;
              this.global.dt2table1[this.iRow]['Quantity'] = this.tempDay;
            }
            //console.log('No clicked');
          }
        }
      ]
    });
    alert.present();
  }

  presentNAalert(gridtype: number, resMsg: string) {
    let alert = this.alertCtrl.create({
      subTitle: resMsg.replace('NA', ''),
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          handler: () => {
            if (gridtype == 1) {
              this.global.dt1table1[this.iRow]['StartTime'] = this.tempStartTime;
              this.global.dt1table1[this.iRow]['FinishTime'] = this.tempEndTime;
              this.global.dt1table1[this.iRow]['BreakTime'] = this.tempBreakTime;
              this.global.dt1table1[this.iRow]['TotalTime'] = this.tempTotalTime;

            } else if (gridtype == 2) {
              this.tempDisableGrid2Change = true;
              this.global.dt2table1[this.iRow]['Quantity'] = this.tempDay;
            }
            //console.log('Ok clicked');
          }
        }
      ]
    });
    alert.present();
  }

  async pickerOfgrid1Type(iRow: number, type: string) {
    // debugger;
    this.iRow = iRow;
    
    
    ////check if starttime > endtime --- if yes , show alert and revert back value
    var currentStartTime =  this.global.dt1table1[iRow]['DefaultStartTime'];
    var currentEndTime =  this.global.dt1table1[iRow]['DefaultEndTime'];

    var isStartTimeGreater = this.isT2Greater(currentEndTime, currentStartTime);
    if(isStartTimeGreater && currentEndTime!="00:00" && this.global.agencyid != "114"){ //TTG2713 : exclude bauhaus from this check

      ///revert old data
      this.global.dt1table1[iRow]['DefaultStartTime'] = this.tempStartTime;
      this.global.dt1table1[iRow]['DefaultEndTime'] = this.tempEndTime;
      // this.global.dt1table1[iRow]['DefaultStartTime'] = this.tempStartTime;

      this.global.presentToast("End time cannot be before the start time.", 10000);
      // let alert = this.alertCtrl.create({
      //   subTitle: "End time cannot be before the start time.",
      //   buttons: [
      //     {
      //       text: 'OK',
      //       role: 'cancel',
      //       handler: () => {
              
      //         //console.log('Ok clicked');
      //       }
      //     }
      //   ]
      // });
      // await alert.present();

      
      
    } else {


        //TO BE DISPLAYED IN INPUT TEXBOX THAT OVERLAPS ION-DATETIME
        ///Ion-datetime reads from default start/end/break fields 
        ///ion-input reads from start/end/break fields 
        ///made so we can control the default value to open to ,,, even if real value is zero 
        

      if (type == "start") {

        if (this.global.TimeInputControl == '12') {
          this.global.dt1table1[iRow]['StartTime'] = this.t_convert_24_to_ampm(this.global.dt1table1[iRow]['DefaultStartTime']);
        } else {
          this.global.dt1table1[iRow]['StartTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[iRow]['DefaultStartTime']);
        }

      }

      if (type == "finish") {

        if (this.global.TimeInputControl == '12') {
          this.global.dt1table1[iRow]['FinishTime'] = this.t_convert_24_to_ampm(this.global.dt1table1[iRow]['DefaultEndTime']);
        } else {
          this.global.dt1table1[iRow]['FinishTime'] = this.t_convert_ampm_to_24(this.global.dt1table1[iRow]['DefaultEndTime']);
        }

      }

      if (type == "break") {
        this.global.dt1table1[iRow]['BreakTime'] = this.global.dt1table1[iRow]['DefaultBreakTime'];
      }


      //console.log('START TIME: ' + this.global.dt1table1[iRow]['StartTime']);
      //console.log('FINISH TIME: ' + this.global.dt1table1[iRow]['FinishTime']);


      var starttime = this.t_convert_ampm_to_24(this.global.dt1table1[iRow]['StartTime']);
      var finishtime = this.t_convert_ampm_to_24(this.global.dt1table1[iRow]['FinishTime']);
      var breaktime = this.global.dt1table1[iRow]['BreakTime'];

      var totaltime = this.calculateTotalTime(starttime, finishtime, breaktime);
      this.global.dt1table1[iRow]['TotalTime'] = totaltime;

      this.httpRequestGrid1_save(1, 'CHECK', totaltime);
    }
  }

  timeToMinutes(t) {
    const timeParts = t.split(':');
    if (timeParts.length !== 2) {
        throw new Error(`Invalid time format: ${t}. Expected 'HH:MM'.`);
    }

    let [hours, minutes] = timeParts.map(part => parseInt(part, 10));

    if (
        isNaN(hours) || isNaN(minutes) ||
        hours < 0 || hours > 23 ||
        minutes < 0 || minutes > 59
    ) {
        throw new Error(`Invalid time value: ${t}. Hours should be 0-23 and minutes 0-59.`);
    }

    return hours * 60 + minutes;
  }

  isT2Greater(t1, t2) {
    // Helper function to convert 'HH:MM' to total minutes
    

    const t1Minutes = this.timeToMinutes(t1);
    const t2Minutes = this.timeToMinutes(t2);

    return t2Minutes > t1Minutes;
  }


  grid2Change(i: number) {
    // console.log("111");

    if(this.tempDisableGrid2Change){
      this.tempDisableGrid2Change = false;
      return;
    }

    this.iRow = i;
    var value = this.global.dt2table1[i].Quantity;
    if (value == "") { value = "0"; }
    // if (value.includes("-")) { value = "0"; this.global.dt2table1[i].Quantity = "0";  }
    var number = parseFloat(value);
    if (number < 0) { value = "0"; this.global.dt2table1[i].Quantity = value; } //min
    if (number > 3) { value = "3"; this.global.dt2table1[i].Quantity = value; } //max
    this.httpRequestGrid1_save(2, "CHECK", value);
  }

  onFocusGrid2(event: Event, ix: number) {
    var ev = event.currentTarget as HTMLInputElement;
    if (ev.value == "0") {
      this.global.dt2table1[ix].Quantity = "";
    }
  }

  // public restrictNumeric(e) {
  //   let input;

  //   if((e.which >= 48 && e.which <= 57) || (e.which >= 96 && e.which <= 105)){
  //     return true;
  //   } else {
  //     return false;
  //   }
  //   // if ( e.which !== 190 && e.which !== 48 && e.which !== 49 && e.which !== 50 && e.which !== 51 && e.which !== 52 && e.which !== 53 && e.which !== 54 && e.which !== 55 && e.which !== 56 && e.which !== 57 ){
  //   //   return false;
  //   // }
  //   // if (e.which === 45) {
  //   //  return false;
  //   // }
  //   // if (e.which === 109) {
  //   //   return false;
  //   // }
  //   // if (e.which === 189) {
  //   //   return false;
  //   // }

  //   input = String.fromCharCode(e.which);
  //   return !!/[\d\s]/.test(input);
  //  }
  // fn_numeric(i: number){

  //   debugger;
  //   var value = this.global.dt2table1[i].Quantity;

  //   if(isNaN(Number(value))){
  //     console.log("not number");

  //     this.global.dt2table1[i].Quantity = "";
  //   }

  // }

  timeInterval() {

    if (this.allowbetweeninterval == true && this.global.agencyid != "1") this.interval = 1; //disable this for oruk, should be ignored in case of ts4 ,, but i don't wqnt to rock boats for aus and ellis 
    else this.interval = Number(this.global.CTRLInterval);

    var updatedInterval = 0;
    this.minuteItervals = new Array;
    this.minuteItervals[0] = 0;
    var i = 1;
    while (updatedInterval + this.interval < 60) {
      //debugger;
      updatedInterval = updatedInterval + this.interval;
      this.minuteItervals[i] = updatedInterval;
      i = i + 1;
    }

    this.minuteItervalsString = this.minuteItervals.join(',');
    //console.log('minutes values:' + this.minuteItervalsString);

    this.hourInterval = new Array;
    for (i = 0; i <= 6; i++) {

      this.hourInterval[i] = i;

    }
    this.hourItervalsString = this.hourInterval.join(',');

    //to make the hours string start at 12 instead of 1 for 12hours format
    //as it caused issue with 00:15 AM , it opened to 01:15 AM instead of 12:15 AM

    if (this.global.TimeInputControl == '12')
      this.startEndHoursString = '12,1,2,3,4,5,6,7,8,9,10,11  #hour';
    else
      this.startEndHoursString = '0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23  #hour';


  }

  saveTemp(gridtype: number, iRow: number) {
    
    this.iRow = iRow;

    if(gridtype == 1){

      this.tempStartTime = this.global.dt1table1[iRow]['StartTime'];
      this.tempEndTime = this.global.dt1table1[iRow]['FinishTime'];
      this.tempBreakTime = this.global.dt1table1[iRow]['BreakTime'];

      this.tempTotalTime = this.calculateTotalTime(this.tempStartTime, this.tempEndTime, this.tempBreakTime);
      

    } else if(gridtype == 2){
      
      this.tempDay = this.global.dt2table1[iRow]['Quantity'];

    }
  }


}



// WEBPACK FOOTER //
// ./src/components/timesheet1/timesheet1.ts